// Captures Chrome's install prompt as early as possible (it often fires before React mounts).
const KEY = "__vskInstallPrompt";

export function captureInstallPrompt() {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window[KEY] = e;
    window.dispatchEvent(new Event("vsk-install-ready"));
  });
  window.addEventListener("appinstalled", () => {
    window[KEY] = null;
    localStorage.setItem("vismarks_app_installed", "1");
    window.dispatchEvent(new Event("vsk-install-done"));
  });
}

export const getDeferredPrompt = () => (typeof window !== "undefined" ? window[KEY] || null : null);

export const isStandalone = () =>
  typeof window !== "undefined" && (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);

export function detectPlatform() {
  const ua = navigator.userAgent || "";
  const ios = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const android = /android/i.test(ua);
  const inApp = /FBAN|FBAV|FB_IAB|Instagram|WhatsApp|Twitter|TikTok|Snapchat|Line\/|MicroMessenger|; wv\)/i.test(ua);
  const safari = ios && /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
  const chrome = /chrome|crios/i.test(ua) && !/edg|opr|samsungbrowser/i.test(ua);
  const samsung = /samsungbrowser/i.test(ua);
  const edge = /edg/i.test(ua);
  const firefox = /firefox|fxios/i.test(ua);
  return { ios, android, inApp, safari, chrome, samsung, edge, firefox, desktop: !ios && !android, standalone: isStandalone() };
}

export async function triggerInstall() {
  const d = getDeferredPrompt();
  if (!d) return "unavailable";
  d.prompt();
  const { outcome } = await d.userChoice;
  window[KEY] = null;
  return outcome;
}

export const openInChromeIntent = (path = "/app") =>
  `intent://${window.location.host}${path}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(window.location.origin + path)};end`;
